import * as React from "react";

const Reports: React.FC = () => {
	return <div className="container"></div>;
};

export default Reports;
